import { dateShortWeekdayFormatter, hourMinuteFormatter } from '@dreryk/react-common';

export const appointmentDateFormatter = (beginDate: Date, endDate: Date): string =>
   `${dateShortWeekdayFormatter(beginDate)} ${hourMinuteFormatter(beginDate)}-${hourMinuteFormatter(endDate)}`;
